import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
// Styles
import { useTheme } from "@mui/material/styles";
import useStyles from "assets/jss/material-react/views/italmundoStyles";
// Components
import PageContainer from "../../components/PageContainer/PageContainer";
import { Grid, Box, Button, useMediaQuery, FormControl } from "@mui/material";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/es";
import * as dayjs from "dayjs";
import { esES } from "@mui/x-date-pickers/locales";
import { Redireccion } from "../../components/Modals";
import {
  SelectGenero,
  SelectNacionalidad,
  SelectTipoEmpleo,
  SelectCargo,
  IngresoLiquido,
  SelectDepartamento,
  SelectBarrio,
  SelectTipoDireccion,
  Direccion,
  Esquinas,
  ObservacionesDireccion,
} from "./Inputs";
// Assets
import { ArrowForward } from "@mui/icons-material";
import { DatosPersonalesIcon, DatosLaboralesIcon, DireccionIcon } from "assets";
// Services
import PublicServices from "services/publicService";
import ClientService from "services/clientService";
import {
  useRedirect,
  getProductNameById,
  URLs,
} from "../../utils/redirectStep";

function DatosLaborales() {
  //Inicializaciones base
  const clientService = new ClientService();
  const publicService = new PublicServices();
  const { checkAndRedirect } = useRedirect();
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const itIsSecondCall = useRef(false);
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = React.useState(false);

  const [modal, setModal] = useState({
    open: false,
    title: "",
    message: "",
    content: null,
    showX: true,
  });

  // Inicializaciones particulares
  const [nacionalidades, setNacionalidades] = React.useState([]);
  const [tiposEmpleo, setTiposEmpleo] = React.useState([]);
  const [tipoEmpleo, setTipoEmpleo] = React.useState([]);
  const [cargos, setCargos] = React.useState([]);
  const [allCargos, setAllCargos] = React.useState([]);
  const [localidades, setLocalidades] = React.useState([]);
  const [allLocalidades, setAllLocalidades] = React.useState([]);
  const [departamentos, setDepartamentos] = React.useState([]);
  const [progress, setProgress] = useState(0);
  const [showEsquinas, setShowEsquinas] = useState(false);
  const [clientType2, setClientType2] = useState(false);
  const [showFechaIngreso, setShowFechaIngreso] = useState(false);
  const [showIngresoLiquido, setShowIngresoLiquido] = useState(false);
  const [direccionLabel, setDireccionLabel] = useState("Dirección*");
  const [searchParams, setSearchParams] = useSearchParams();
  // const [itIsSecondCall, setItIsSecondCall] = useState(false);
  const soloIngreso = [5, 9, 10];
  const sinCampos = [7, 8];
  const [user, setUser] = useState({
    sexo: "",
    nacionalidad: null,
    fechaNacimiento: "",
    idTipoEmpleo: "",
    idCargo: "",
    fechaIngreso: "",
    ingresoLiquido: "",
    codigoDepartamento: "",
    idDepartamento: "",
    idBarrio: "",
    idTipoDireccion: "",
    dirección: "",
    observacionesDireccion: "",
    esquina1: "",
    esquina2: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    checkAndRedirect(openModalRedirect, 2, params.toString());
  }, []);

  const openModalRedirect = () => {
    setModal({
      open: true,
      showX: false,
      content: <Redireccion />,
    });
  };

  const buildNavigateUrl = (path) => {
    const params = new URLSearchParams(searchParams);
    return `${path}?${params.toString()}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      const getAllNacionalidades = await publicService.getNacionalidades();
      const mappedNacionalidades = getAllNacionalidades.data.map((x) => {
        return {
          label: x.descripcion,
          id: x.codigo,
        };
      });
      setNacionalidades(mappedNacionalidades);
      const getAllTiposEmpleo = await publicService.getTiposDeProfesiones();
      setTiposEmpleo(getAllTiposEmpleo.data);
      const getAllCargos = await publicService.getProfesionesRamos();
      setAllCargos(getAllCargos.data);
      const departamentosLocalidades = await publicService.getDepartamentosLocalidades();
      setAllLocalidades(departamentosLocalidades.data);
      const idDeptoUnicos = {};
      const deptosFiltrados = departamentosLocalidades.data.filter((objeto) => {
        if (!idDeptoUnicos[objeto.idDepto]) {
          idDeptoUnicos[objeto.idDepto] = true;
          return true;
        }
        return false;
      });

      setDepartamentos(deptosFiltrados);
    };
    fetchData();
  }, []);

  const handleModalCloseClick = () => {
    if (clientType2) {
      navigate(buildNavigateUrl("/"));
    }
    setModal({ ...modal, open: false });
  };

  const handleIngresoLiquidoInput = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, "");
    if (inputValue.length > 6) {
      inputValue = inputValue.slice(0, 6);
    }
    setUser({ ...user, ingresoLiquido: inputValue });
  };

  const parseIngresoLiquido = (inputValue) => {
    if (!inputValue) return null;
    const normalizedValue = inputValue.replace(",", ".");
    const parsedValue = parseFloat(normalizedValue);
    return isNaN(parsedValue) ? null : parsedValue;
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    if (name === "observacionesDireccion") {
      if (value.length > 100) {
        return;
      }
    }

    setUser({ ...user, [name]: value });
    if (name === "idTipoEmpleo") {
      setCargos(allCargos.filter((x) => x.codigoProfesion === value));
      const tipoDeEmpleoElegido = tiposEmpleo.find(
        (tipo) => tipo.codigo === value
      );
      setTipoEmpleo(tipoDeEmpleoElegido);
      if (sinCampos.includes(value)) {
        setShowFechaIngreso(false);
        setShowIngresoLiquido(false);
      } else {
        setShowIngresoLiquido(true);
        if (soloIngreso.includes(value)) {
          setShowFechaIngreso(false);
        } else {
          setShowFechaIngreso(true);
        }
      }
    }

    if (name === "idDepartamento") {
      var depto = departamentos.filter((x) => x.idDepto === value)[0];
      var localidadesFiltradas = allLocalidades.filter(
        (x) => x.idDepto === depto.idDepto
      );
      setLocalidades(localidadesFiltradas);
      setUser({
        ...user,
        codigoDepartamento: depto.codigoDepartamento,
        idDepartamento: depto.idDepto,
      });
    }

    if (name === "idBarrio") {
      var idBarrio = value;
      setUser({
        ...user,
        idBarrio: idBarrio,
      });
    }

    // if (name === "idTipoDireccion") {
    //   if (value === "2") {
    //     setShowEsquinas(true);
    //   } else {
    //     setShowEsquinas(false);
    //   }
    // }

    if (name === "idTipoDireccion") {
      switch (value) {
        case "2":
          setDireccionLabel("Dirección*");
          setShowEsquinas(true);
          break;
        case "3":
          setDireccionLabel("Ruta - Kilómetro*");
          setShowEsquinas(false);
          break;
        case "4":
          setDireccionLabel("Nombre del Inmueble*");
          setShowEsquinas(false);
          break;
        default:
          setDireccionLabel("Dirección*");
          setShowEsquinas(false);
      }
    }
  };

  const handleDateChange = (name, date) => {
    setUser({ ...user, [name]: date });
  };

  const handleValidation = () => {
    let valid = true;
    let newErrors = {};

    for (const field in user) {
      if (field !== "observacionesDireccion" && !user[field]) {
        if (field === "fechaIngreso" && !showFechaIngreso) {
          // no hacemos nada
        } else {
          if (field === "ingresoLiquido" && !showIngresoLiquido) {
            // no hacemos nada
          } else {
            if (
              user.idTipoDireccion == 2 &&
              (field == "esquina1" || field == "esquina2")
            ) {
              newErrors[field] = "Este campo es obligatorio";
              valid = false;
            } else if (field != "esquina1" && field != "esquina2") {
              newErrors[field] = "Este campo es obligatorio";
              valid = false;
            }
          }
        }
      }
    }
    setErrors(newErrors);
    return valid;
  };

  const today = dayjs();
  const maxDate = dayjs(today.add(-18, "year"), today.month, today.day);
  const minDate = dayjs(today.add(-75, "year"), today.month, today.day);

  const navigateToOffer = (location, response) => {
    const newTransaction = {
      ...location.state.transaction,
      tipoDeEmpleoElegido: tipoEmpleo,
      codigoProducto: response.data.producto.codigoProducto,
    };

    const nombreProducto = getProductNameById(
      response.data.producto.codigoProducto
    );

    if (nombreProducto) {
      navigate(buildNavigateUrl(`${URLs.oferta}/${nombreProducto}`), {
        state: {
          transaction: newTransaction,
          userData: response.data,
        },
      });
    }
  };

  const handleContinue = async () => {
    if (!handleValidation()) {
      return;
    }
    setLoading(true);

    const tipoEmpleo = tiposEmpleo.filter(
      (x) => x.codigo === user.idTipoEmpleo
    )[0];
    const docRequerida = tipoEmpleo.documentacionRequerida.filter(
      (x) => x.id !== 1 && x.id !== 2
    );

    let progressValue = 0;
    let apiResponse = null;

    const updateProgress = (increment = 4) => {
      progressValue += increment;
      if (progressValue > 100) progressValue = 100;
      setProgress(progressValue);
      setModal(() => ({
        open: true,
        showX: false,
        content: (
          <>
            <h3 className={classes.modalTitle}>
              Estamos procesando tu información
            </h3>
            <p
              className="special-font"
              style={{
                fontWeight: 700,
                color: "#04808F",
                marginTop: "1.5rem",
                fontSize: "17px",
              }}
            >
              {progressValue}%
            </p>
            <Box
              sx={{
                width: "80%",
                borderRadius: "5px",
                padding: "2px",
                border: "1px solid #04808F",
                marginTop: "0.5rem",
                marginBottom: "1.5rem",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  backgroundColor: "#CDE6E9",
                  borderRadius: "5px",
                }}
              >
                <Box
                  sx={{
                    width: `${progressValue}%`,
                    backgroundColor: "#04808F",
                    height: "20px",
                    borderRadius: "5px",
                  }}
                />
              </Box>
            </Box>
          </>
        ),
      }));
    };

    const handleApiResponse = (response) => {
      const newTransaction = {
        ...location?.state?.transaction,
      };
      if (response.code === 500) {
        if (itIsSecondCall.current) {
          navigate(buildNavigateUrl(URLs.intenteLuego), {
            state: {
              transaction: newTransaction,
            },
          });
        } else {
          itIsSecondCall.current = true;
          openModalDeEsperaParaUsuario();
          setTimeout(() => {
            handleContinue();
          }, 3000);
        }
      } else {
        if (response.data.codeError === 1) {
          setModal({ ...modal, open: false });
          navigate(buildNavigateUrl(URLs.intenteLuego), {
            state: {
              transaction: newTransaction,
            },
          });
        } else if (response.data.clientType === 2) {
          navigate(buildNavigateUrl(URLs.rechazada));
        } else {
          navigateToOffer(location, response);
        }
      }
      setLoading(false);
    };

    const userData = getUserData();
    const apiPromise = clientService.getOffer(
      userData,
      location?.state?.transaction
    );
    const progressInterval = setInterval(async () => {
      if (apiResponse?.data?.producto || progressValue >= 100) {
        if (progressValue < 100) {
          updateProgress(100 - progressValue);
        }
        clearInterval(progressInterval);
        setTimeout(async () => {
          try {
            const response = apiResponse || (await apiPromise);
            handleApiResponse(response);
          } catch (error) {
            console.error("Error handling API call:", error);
          }
        }, 2000);
      } else {
        updateProgress();
      }
    }, 1200);

    try {
      apiResponse = await apiPromise;
    } catch (error) {
      console.error("Error fetching API response:", error);
    }
  };

  const getUserData = () => {
    var obsDireccion =
      user.idTipoDireccion === "2"
        ? `${user.esquina1}, ${user.esquina2} | ${user.observacionesDireccion}`
        : user.observacionesDireccion;
    var userData = {
      ...user,
      nacionalidad: user.nacionalidad.id,
      idTipoDireccion: parseInt(user.idTipoDireccion),
      observacionesDireccion: obsDireccion,
      fechaNacimiento: user.fechaNacimiento.format("YYYY-MM-DDTHH:mm:ss"),
      fechaIngreso: showFechaIngreso
        ? user.fechaIngreso.format("YYYY-MM-DDTHH:mm:ss")
        : "0001-01-01T00:00:00",
      ingresoLiquido: parseIngresoLiquido(user.ingresoLiquido),
    };

    delete userData.esquina1;
    delete userData.esquina2;
    return userData;
  };

  const openModalDeEsperaParaUsuario = () => {
    const message = `<p className={classes.modalMessage}><span style="color: #d00771!important">¡Gracias por tu paciencia!</span><br /><br />Estamos procesando tu información,<br />solo tomará un momento más.</p>`;
    setModal({
      open: true,
      showX: false,
      message: message,
    });
  };

  const LabelAUnPaso = () => {
    return (
      <p
        className={classes.labelAUnPaso}
        style={{
          fontSize: mobile ? "14px" : "17px",
        }}
      >
        ¡ESTÁS A UN PASO DE TENERLA!
      </p>
    );
  };

  const Icono = ({ icono }) => {
    return <img src={icono} className={classes.iconLaborales} />;
  };

  const Subtitulo = ({ icono, titulo }) => {
    return (
      <div className={classes.divSubtitulo}>
        <Icono icono={icono} />
        <p
          style={{
            fontSize: "14px",
            fontWeight: "520",
          }}
        >
          {titulo}
        </p>
      </div>
    );
  };

  return (
    <PageContainer
      loading={loading}
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.datosLaborales}
    >
      <ProgressBar currentStep={"PASO 3"} sx={{ marginTop: "0.5rem" }} />
      <LabelAUnPaso />

      <Subtitulo icono={DatosPersonalesIcon} titulo={"DATOS PERSONALES"} />
      <Grid container spacing={mobile ? 0 : 3.5}>
        <SelectGenero
          handleChange={handleInputChange}
          user={user}
          errors={errors}
        />
        <SelectNacionalidad
          setUser={setUser}
          user={user}
          errors={errors}
          nacionalidades={nacionalidades}
        />
        <Grid item xs={12} sm={6} className={classes.gridForm}>
          <FormControl
            fullWidth
            variant="filled"
            error={!!errors.fechaNacimiento}
            className={`${classes.datePickerCustom} ${
              user.fechaNacimiento === "" ? "" : classes.marginDatePickerCustom
            } ${errors.fechaNacimiento != null ? classes.colorRed : ""}`}
          >
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="es"
              localeText={
                esES.components.MuiLocalizationProvider.defaultProps.localeText
              }
            >
              <DatePicker
                id="fechaNacimiento"
                name="fechaNacimiento"
                label="Fecha de nacimiento*"
                format="DD/MM/YYYY"
                maxDate={maxDate}
                minDate={minDate}
                onChange={(date) => handleDateChange("fechaNacimiento", date)}
                error={!!errors.fechaNacimiento}
                helperText={errors.fechaNacimiento}
                className={classes.datePicker}
              />
            </LocalizationProvider>
          </FormControl>
        </Grid>
      </Grid>

      <Subtitulo icono={DatosLaboralesIcon} titulo={"DATOS LABORALES"} />
      <Grid container spacing={mobile ? 0 : 3.5}>
        <SelectTipoEmpleo
          handleChange={handleInputChange}
          user={user}
          errors={errors}
          tiposEmpleo={tiposEmpleo}
        />
        <SelectCargo
          handleChange={handleInputChange}
          user={user}
          errors={errors}
          cargos={cargos}
        />
        {showFechaIngreso && (
          <Grid item xs={12} sm={6} className={classes.gridForm}>
            <FormControl
              fullWidth
              variant="filled"
              error={!!errors.fechaIngreso}
              className={`${classes.datePickerCustom} ${
                user.fechaNacimiento === ""
                  ? ""
                  : classes.marginDatePickerCustom
              } ${errors.fechaNacimiento != null ? classes.colorRed : ""}`}
            >
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="es"
                localeText={
                  esES.components.MuiLocalizationProvider.defaultProps
                    .localeText
                }
              >
                <DatePicker
                  id="fechaIngreso"
                  name="fechaIngreso"
                  label="Fecha de ingreso*"
                  format="DD/MM/YYYY"
                  maxDate={dayjs()}
                  onChange={(date) => handleDateChange("fechaIngreso", date)}
                  error={!!errors.fechaIngreso}
                  helperText={errors.fechaIngreso}
                  className={classes.datePicker}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
        )}
        <IngresoLiquido
          handleOnInput={handleIngresoLiquidoInput}
          user={user}
          errors={errors}
          show={showIngresoLiquido}
        />
      </Grid>

      <Subtitulo icono={DireccionIcon} titulo={"DOMICILIO"} />
      <Grid container spacing={mobile ? 0 : 3.5}>
        <SelectDepartamento
          handleChange={handleInputChange}
          user={user}
          errors={errors}
          departamentos={departamentos}
        />
        <SelectBarrio
          handleChange={handleInputChange}
          user={user}
          errors={errors}
          localidades={localidades}
        />
        <SelectTipoDireccion
          handleChange={handleInputChange}
          user={user}
          errors={errors}
        />
        <Direccion
          handleChange={handleInputChange}
          user={user}
          errors={errors}
          label={direccionLabel}
        />
        <Esquinas
          handleChange={handleInputChange}
          user={user}
          errors={errors}
          show={showEsquinas}
        />
        <ObservacionesDireccion
          handleChange={handleInputChange}
          user={user}
          errors={errors}
        />
      </Grid>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          width: "100%",
          margin: "auto",
          marginTop: "2rem",
        }}
      >
        <p
          style={{
            fontSize: "12px",
            lineHeight: "1.2",
            fontWeight: "480",
            margin: 0,
            marginRight: mobile ? "1rem" : "1.5rem",
          }}
        >
          CONFIRMAR
        </p>
        <Button
          variant="text"
          className={` ${classes.containedBtn} `}
          disabled={loading}
          onClick={handleContinue}
          style={{
            width: "20px",
            marginRight: "1rem",
            borderRadius: "8px",
          }}
        >
          <ArrowForward sx={{ fontSize: 25 }} />
        </Button>
      </Box>
    </PageContainer>
  );
}

export default DatosLaborales;
